export default [
    'Yes',
    'No',
    'Partial'
];